export const ENDPOINT = {
    /* NEWS FEED */
    GET_NEWS_FEED: "util/news",

    /* HELP */
    GET_HELP: "util/help",
};
